import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const MultipleAccessAloha = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Multiple Access: Pure Aloha & Slotted Aloha"
    videos={[
      "https://www.youtube.com/embed/j4-r0e7DjqY",
      "https://www.youtube.com/embed/aqWTNk90zRA",
      "https://www.youtube.com/embed/QnwlWbKf-fM?t=987"
    ]}
    takeaways={[
      { text: "Try solving problems on this topic; the problems can be a bit confusing." }
    ]}
    questions={[
      "A slotted ALOHA network transmits 800-bit frames using a shared channel with 400 kbps bandwidth. Find the throughput if the system (all stations together) produces i. 2000 frames per second ii.1000 frames per second iii.500 frames per second. Also find the vulnerability.",
      "Assuming N stations are present in a pure Aloha Network, having a bandwidth of 56Kb/Sec, find the value of N, assuming that each station sends data of size 1000 bits at an average interval of 100 sec.",
      "In a Slotted ALOHA system, the channel has a transmission capacity of 1 Mbps. The average packet size is 1000 bits. Calculate the maximum throughput of the system.",
      "In a Slotted ALOHA network, 10 users are attempting to send packets, and each user generates packets at a rate of 0.5 packets per second. Calculate the probability of a packet collision when one user attempts to send a packet."
    ]}
    exampleVideos={[]}
  />
);
}

export default MultipleAccessAloha;
